import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { NONE, VALUE, UNLIMITED } from "const"
import { MtAccountPackage } from "server/models"
import { StoreType, addModal } from "client/store"
import {
    TableColumn,
    DateFormatter,
    Link,
} from "client/components"

import EditAccountPackage from "./edit"

const Columns = () => {
    const packageList = useSelector((state: StoreType) => state.package.packageList)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const columns: TableColumn[] = [
        {
            field: "packageId",
            header: lang.package,
            cellMinWidth: "200px",
            formatter: (row: MtAccountPackage) => {
                const { packageId } = row
                if (!packageList[packageId]) return null

                if (userData.accountId === 1) {
                    return (
                        <Link
                            href="/#"
                            onClick={() => dispatch(addModal({
                                key: "editPackage",
                                content: <EditAccountPackage id={row.id} accountId={row.accountId} />,
                            }))}
                        >
                            {packageList[packageId].name}
                        </Link>
                    )
                }
                return packageList[packageId].name
            },
        },
        {
            field: "dateStart",
            header: lang.dateStart,
            cellWidth: "200px",
            cellMinWidth: "200px",
            formatter: (row: MtAccountPackage) => <DateFormatter date={row.dateStart} showTime={false} />,
        },
        {
            field: "dateEnd",
            header: lang.dateEnd,
            cellWidth: "200px",
            cellMinWidth: "200px",
            formatter: (row: MtAccountPackage) => <DateFormatter date={row.dateEnd} showTime={false} />,
        },
        {
            field: "paymentOption",
            header: lang.paymentMethod,
            cellMinWidth: "150px",
            formatter: (row: MtAccountPackage) => lang[row.paymentOption],
        },
    ]

    if (userData.accountId === 1) {
        columns.push({
            field: "stripePaymentId",
            header: lang.stripeOrder,
            cellMinWidth: "150px",
            formatter: (row: MtAccountPackage) => {
                const { stripePaymentId } = row
                if (stripePaymentId) {
                    // TODO: change test mode to real
                    const href = `https://dashboard.stripe.com/test/payments/${stripePaymentId}`
                    return <a href={href} target="_blank" rel="noreferrer">{stripePaymentId}</a>
                }
                return null
            },
        })
    }

    columns.push(
        {
            field: "packageCalculations",
            header: lang.packageCalculations,
            formatter: (row: MtAccountPackage) => {
                const { packageId } = row
                if (!packageList[packageId]) return null

                const { silCalculations, silCalculationsValue } = packageList[packageId].settingsParsed
                if (silCalculations === NONE) return lang.none
                if (silCalculations === VALUE) return silCalculationsValue
                if (silCalculations === UNLIMITED) return lang.unlimited
                return null
            },
        },
        {
            field: "additionalCalculations",
            header: lang.additionalCalculations,
            formatter: (row: MtAccountPackage) => row.additionalSilCalculations,
        },
        {
            field: "usedCalculations",
            header: lang.usedCalculations,
            formatter: (row: MtAccountPackage) => row.usedSilCalculations,
        },
    )

    return columns
}
export default Columns
